"use client";

import clsx from "clsx";

// icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// i18n
import { Link } from "@/i18n/navigation";

export default function ContactInfoCard({ items = [] }) {
    return (
        <div className="flex flex-col gap-10 p-6 rounded-lg border border-primary-weak md:gap-0 md:items-center md:justify-between md:flex-row lg:px-10">
            {items.map((item) => (
                <div className={clsx("flex gap-4 items-center",item.wrapperClassName)} key={item.id}>
                    {item.icon && <FontAwesomeIcon icon={item.icon} className={clsx("text-[25px] text-primary-default", item.iconClassName)} />}
                    <div className="flex flex-col gap-1">
                        <span className="text-lg font-semibold leading-26 text-foreground-default">{item.title}</span>
                        {item.redirectUrl ? (
                            <Link 
                                href={item.redirectUrl}
                                className="text-base font-normal leading-21 text-foreground-default hover:text-primary-default transition-colors"
                            >
                                {item.value}
                            </Link>
                        ) : (
                            <span className="text-base font-normal leading-21 text-foreground-default">{item.value}</span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}